import axios from 'axios';
import router from '../router/index';
import $ from 'jquery';
import Vue from 'vue';
import { Message } from 'element-ui';
const subevents = {
    state: () => ({
        items: [],
        programItems: [],
        filter: {
            searchTerm: null,
            skip: 0,
            take: 1000,
            total: 0,
            page: 1,
            totalRecords:0,
        },
        selectedItems: [],
        loading: true,
    }),
    mutations: {
        setSubEvents(state, payload) {
            state.items = payload.items;
            state.filter.total = payload.totalCount;
            var totalRecords = 0;
        
            payload.items.map(x => {
                totalRecords += x.pending;
            })
            state.filter.totalRecords = totalRecords;
        },
        setProgramSubList(state, payload) {
            state.programItems = payload.items;
        },
        setSelectedSubEvents(state, payload) {
            state.selectedItems = payload;
        },
        setSubEventPage(state, payload) {
            state.filter.page = payload;
            this.dispatch('getSubEvents');
        },
        setSubEventTake(state, payload) {
            state.filter.page = 1;
            state.filter.take = payload;
            this.dispatch('getSubEvents');
        },
    },
    actions: {
        async saveSubEventOrder(context, payload) {
            var res = await axios.post('/SubEvent/UpdateOrderNos', { ids: payload });
            if (res.data.alert.hasError) {
                Message.error(res.data.alert.message);
            } else {
                Message.success(res.data.alert.message);
            }
        },
        async addUpdateSubEvent(store, payload) {
            var res = await axios.post('/SubEvent/AddOrUpdate', payload);
            if (res.data.alert.hasError) {
                Message.error(res.data.alert.message);
            } else {
                Message.success(res.data.alert.message);
                store.dispatch('getSubEvents');
            }
            return res;
        },
        async getSubEvent(store, payload) {
            var res = await axios.post('/SubEvent/Get', { id: payload });
            if (res.data.alert.hasError) {
                Message.error(res.data.alert.message);
            }
            return res;
        },
        async getSubEvents(store) {
            store.state.loading = true;
            var res = await axios.post('subevent/list', {
                ...store.state.filter,
                skip: 0,
            });
            store.state.loading = false;
            return store.commit('setSubEvents', res.data.data);
        },
        async togglerSubEvent(store, payload) {
            var res = await axios.post('/SubEvent/ToggleISActive', {
                id: payload,
            });
            if (res.data.alert.hasError) {
                Message.error(res.data.alert.message);
            } else {
                Message.success(res.data.alert.message);
            }
            return res.data;
        },
        async toggleSubEvent(store, payload) {
            var res = await axios.post('subevent/toggleisactive', {
                id: store.state.items[payload.index].id,
            });
            return res.data;
        },
        async deleteSubEvent(store, payload) {
            var res = await axios.post('subevent/delete', {
                id: payload,
            });
            if (res.data.alert.hasError) {
                Message.error(res.data.alert.message);
            } else {
                Message.success(res.data.alert.message);
                store.dispatch('getSubEvents');
            }
            return res;
        },
    },
    getters: {},
};
export default subevents;


// WEBPACK FOOTER //
// ./src/store/subevents.js